import { useEffect, useState } from 'react'
import s from './index.module.css'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { getNextReport } from './helters/getNextReport';
import { isCourseAccessGranted } from '@/utils/isCourseAccessGranted/isCourseAccessGranted';
import { useGetId } from '@/hooks/useGetId';
import useRoles from '@/hooks/useRoles';
import { getLinkToMeeting } from '@/helpers/new/getLinkToMeeting';
import { LessonInfo } from './components/LessonInfo';
import { getCurrentReport } from './helters/getCurrentReport';
import { conferenceTypesEnum } from '@modals/Timetable/AddLessonOrMeeting/components/ConferenceType/conferenceTypesEnum';

const Further = ({type = 'next', reports}) => {
  const [lesson, setLesson] = useState(null);
  const childrenId = useGetId();
  const { isChildrenOrParent } = useRoles();
  const timezone = useSelector(store => store.settings?.custom?.timezone);
  useEffect(()=>{
      const getReport = type === 'current' ? getCurrentReport : getNextReport;

      setLesson(getReport(reports ?? [], timezone))
  }, [reports, timezone])
  
  const [accessStatus, setAccessStatus] = useState('error'); 
  // ставим error чтобы ничего не отображал компонент до загрузки accessStatus с сервера

  const setDenyAccess = async () => {
    if(!isChildrenOrParent || !lesson?.direction_id || !childrenId) return;
    try {
      const accessStatus = await isCourseAccessGranted({childrenId: childrenId, directionId: lesson?.direction_id})
      setAccessStatus(accessStatus)
    }
    catch {
      setAccessStatus('error')
    }
  }

  useEffect(()=>{
    setDenyAccess()
  }, [isChildrenOrParent, lesson?.direction_id, childrenId])
  
  if (!lesson || !getLinkToMeeting({report: lesson}) || !lesson?.directionName || !lesson?.start_time || (accessStatus === 'error' && isChildrenOrParent && lesson?.conference_type !== conferenceTypesEnum.customizable)) return <></>
  
  if(isChildrenOrParent && accessStatus === false){
    return(
      <Link to='/payment' className={s.courseTime}>
        <LessonInfo 
          current={type==='current'}
          direction={lesson?.directionName} 
          text={type==='current' ? 'Сейчас' : `Сегодня в ${lesson?.start_time}`} 
        />
      </Link>
    )
  }

  return (
    <a href={getLinkToMeeting({report: lesson})} target='_blank' rel="noreferrer" className={s.courseTime}>
      <LessonInfo 
        current={type==='current'}
        direction={lesson?.directionName} 
        text={type==='current' ? 'Сейчас' : `Сегодня в ${lesson?.start_time}`} 
      />
    </a>
  );
}

export default Further